export enum CoreFaqApiTags {
  FAQList = 'FAQList',
}

export const coreFaqApiTagTypes = Object.values(CoreFaqApiTags);
